// @core/api/endpoints/signature/delete_party.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/signature';

/**
 * Delete a signing party
 * Removes a party from the signing flow on its target. Blocked once status=SIGNED (use revocation instead). Soft-delete by default; hard_delete requires no attached Signatures.
 */
export async function DeleteParty(
  party_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/parties/:party_id`;
  requestPath = requestPath.replace(':party_id', encodeURIComponent(party_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
